const prefix = "/api/v1/jus";

interface AppLinks {
  dmp: string;
  jus: string;
  cpa: string;
  webPush: string;
  adsBox: string;
  reports: string;
  crm: string;
}

interface Links {
  accountView: string;
  documentList: string;
  redirectList: string;
  linkingList: string;
}

interface Endpoints {
  get: {
    documentsList: string;
    apiKey: string;
    loginUrl: string;
    logoutUrl: string;
    accountList: string;
    redirectList: string;
    resourceList: string;
    page: string;
    redirect: string;
    account: string;
    usersList: string;
    pageVersionPreview: string;
    documentsViewAll: string;
    linkingList: string;
    linking: string;
    tags: string;
    accountModules: string;
    permissions: string;
  };
  put: {
    account: string;
    redirect: string;
    page: string;
    users: string;
    linking: string;
  };
  post: {
    account: string;
    page: string;
    pageVersion: string;
    redirect: string;
    clonePage: string;
    exportPage: string;
    importPage: string;
    archivePage: string;
    linking: string;
    downloadPageResources: string;
  };
  delete: {
    account: string;
    redirect: string;
    documentsAll: string;
    linking: string;
    linkingBulk: string;
  };
  redirect: Record<string, never>;
}

export interface Environment {
  baseUrl: string;
  appLinks: AppLinks;
  links: Links;
  endpoints: Endpoints;
  mockApi?: any;
}

export default (baseUrl: string): Environment => ({
  baseUrl,
  appLinks: {
    dmp: "https://rel-admin-dmp.insigit.com/",
    jus: "https://jus.rel.insigit.com/",
    cpa: "https://cpa-admin.rel.insigit.com/",
    webPush: "https://webpush.rel.noclef.com/",
    adsBox: "https://adsbox.rel.insigit.com/",
    reports: "https://reports.rel.insigit.com/managersReport",
    crm: "https://crm.rel.insigit.com/",
  },
  links: {
    accountView: "/accounts/view",
    documentList: "/pages/list",
    redirectList: "/redirects/list",
    linkingList: "/linking/list",
  },
  endpoints: {
    get: {
      documentsList: `${baseUrl}${prefix}/documents/list`,
      apiKey: `${baseUrl}/api/login`,
      loginUrl: `${baseUrl}/login`,
      logoutUrl: `${baseUrl}/logout`,
      accountList: `${baseUrl}${prefix}/accounts/list`,
      redirectList: `${baseUrl}${prefix}/redirects/list`,
      resourceList: `${baseUrl}${prefix}/resources/{versionId}`,
      page: `${baseUrl}${prefix}/documents/{id}`,
      redirect: `${baseUrl}${prefix}/redirects/{id}`,
      account: `${baseUrl}${prefix}/accounts/{id}`,
      usersList: `${baseUrl}${prefix}/users`,
      pageVersionPreview: `${baseUrl}${prefix}/documents/preview/{documentId}`,
      documentsViewAll: `${baseUrl}${prefix}/documents/viewAll`,
      linkingList: `${baseUrl}${prefix}/linking/list`,
      linking: `${baseUrl}${prefix}/linking/{linkingId}`,
      tags: `${baseUrl}${prefix}/tags`,
      accountModules: `${baseUrl}${prefix}/accountModules`,
      permissions: `${baseUrl}${prefix}/userPermissions`,
    },
    put: {
      account: `${baseUrl}${prefix}/accounts/{id}`,
      redirect: `${baseUrl}${prefix}/redirects/{id}`,
      page: `${baseUrl}${prefix}/documents/{id}`,
      users: `${baseUrl}${prefix}/users/{id}`,
      linking: `${baseUrl}${prefix}/linking/{linkingId}`,
    },
    post: {
      account: `${baseUrl}${prefix}/accounts`,
      page: `${baseUrl}${prefix}/documents`,
      pageVersion: `${baseUrl}${prefix}/documentVersion`,
      redirect: `${baseUrl}${prefix}/redirects`,
      clonePage: `${baseUrl}${prefix}/documents/clone`,
      exportPage: `${baseUrl}${prefix}/documents/export`,
      importPage: `${baseUrl}${prefix}/documents/import`,
      archivePage: `${baseUrl}${prefix}/documents/archive/{documentId}`,
      linking: `${baseUrl}${prefix}/linking`,
      downloadPageResources: `${baseUrl}${prefix}/resources/content`,
    },
    delete: {
      account: `${baseUrl}${prefix}/accounts/{id}`,
      redirect: `${baseUrl}${prefix}/redirects`,
      documentsAll: `${baseUrl}${prefix}/documents/deleteAll`,
      linking: `${baseUrl}${prefix}/linking/{linkingId}`,
      linkingBulk: `${baseUrl}${prefix}/linking/bulkDelete`,
    },
    redirect: {},
  },
});

